// extracted by mini-css-extract-plugin
module.exports = {"text":"_62b9db","readMore":"_245417","columnLeft":"_c0c166","columnRight":"_e925d0","shrank":"_0cb8f2"};